import { useQuery } from "@tanstack/react-query";

import type { ILanguage } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";
import { DefaultFetchService } from "app/services/fetchService";

export interface IConfigurationOptions {
    supportedCountriesByChatbot: Record<string, string[]>;
    supportedLanguages: ILanguage[];
}

const fetchService = DefaultFetchService.getInstance();

const fetchConfigurationOptions = async (): Promise<IConfigurationOptions> => {
    return fetchService.get<IConfigurationOptions>("/api/aitracker/configuration-options");
};

export const useConfigurationOptions = () => {
    return useQuery({
        queryKey: ["aitracker", "configuration-options"],
        queryFn: fetchConfigurationOptions,
        staleTime: 24 * 60 * 60 * 1000, // 24 hours
        retry: 1,
    });
};
